export default __webpack_public_path__ + "static/media/finance.269519ee.svg";